const states = {
  loadManifest: { availableStates: ['loading'], nextState: 'loading' },
  loading: { availableStates: ['loadComplete'] },
  loadComplete: { availableStates: ['initialization'], nextState: 'initialization' },
  initialization: { availableStates: ['initializationComplete'], nextState: 'initializationComplete' },
  initializationComplete: { availableStates: ['tutorial'], nextState: 'tutorial' },

  tutorial: { availableStates: ['loadLevel'], nextState: 'loadLevel' },

  loadLevel: { availableStates: ['initLevel'], nextState: 'initLevel' },
  initLevel: { availableStates: ['initLevelComplete'], nextState: 'initLevelComplete' },
  initLevelComplete: { availableStates: ['showing'], nextState: 'showing' },

  showing: { availableStates: ['showingComplete'] },
  showingComplete: { availableStates: ['playing'] },
  playing: { availableStates: ['losing', 'winning', 'win', 'paused', 'skipLevel', 'returnLevel'] },

  skipLevel: { availableStates: ['reset'], nextState: 'reset' },
  returnLevel: { availableStates: ['reset'], nextState: 'reset' },

  paused: { availableStates: ['playing'] },
  winning: { availableStates: ['reset'], nextState: 'reset' },
  win: { availableStates: ['reset'], nextState: 'reset' },
  losing: { availableStates: ['reset'], nextState: 'reset' },
  reset: { availableStates: ['loadLevel'], nextState: 'loadLevel' },
};

export const hiddenSceneStates = [
  'loadManifest',
  'loading',
  'loadComplete',
  'initialization',
  'initializationComplete',
  'tutorial',
  'loadLevel',
  'initLevel',
  'initLevelComplete',
  'showing',
  'showingComplete',
];

export const ignoreNextStates = [
  'paused',
  'countdown',
  'playing',
  'win',
  'winning',
  'losing',
  'skipLevel',
  'returnLevel',
];

export const hiddenControlsStates = [
  'loadManifest',
  'loading',
  'loadComplete',
  'initialization',
  'initializationComplete',
];

export const settings = {
  frozenBaseChance: 0.2,
  frozenIncreaseChance: 0.3,
  frozen_disable_limitations: false,
  frozen_limit_per_game: 30,
  frozen_limit_per_screen: 2,

  protectedBaseChance: 0.2,
  protectedIncreaseChance: 0.3,
  protected_disable_limitations: false,
  protected_limit_per_game: 30,
  protected_limit_per_screen: 3,

  oneColorBaseChance: 0.3,
  oneColorIncreaseChance: 0.001,
  oneColor_disable_limitations: false,
  oneColor_limit_per_game: 30,
  oneColor_limit_per_screen: 2,

  horizontalBaseChance: 0.3,
  horizontalIncreaseChance: 0.001,
  horizontal_disable_limitations: false,
  horizontal_limit_per_game: 30,
  horizontal_limit_per_screen: 2,

  acrossBaseChance: 0.3,
  acrossIncreaseChance: 0.001,
  across_disable_limitations: false,
  across_limit_per_game: 30,
  across_limit_per_screen: 2,

  all_bonus_limitation: 210,
  block_points: 1,
  bonus_duration: 0,
  count10pt: 6,
  count20pt: 8,

  extraPeriodBaseChance: 0.3,
  extraPeriodIncreaseChance: 0.001,
  extraPeriod_disable_limitations: false,
  extraPeriod_limit_per_game: 30,
  extraPeriod_limit_per_screen: 3,

  extraPointsBaseChance: 0.3,
  extraPointsIncreaseChance: 0.001,
  extraPoints_disable_limitations: false,
  extraPoints_limit_per_game: 30,
  extraPoints_limit_per_screen: 3,

  extra_points: 5,

  help_time_limit: 5000,

  scale_points: 1,

  teleportBaseChance: 0.1,
  teleportIncreaseChance: 0.001,
  teleport_disable_limitations: false,
  teleport_limit_per_game: 30,
  teleport_limit_per_screen: 3,

  first_bonus: 50,
  first_bonus_value: 5,
  second_bonus: 100,
  second_bonus_value: 10,
  third_bonus: 250,
  third_bonus_value: 15,

  time_bonus: 5000,
  timerBaseChance: 0.3,
  timerIncreaseChance: 0.001,
  timer_disable_limitation: false,
  timer_limit_per_game: 30,
  timer_limit_per_screen: 3,
};

export const ANIMATION_SIZE = 256;

export const explosionNames = ['remove'];

export const activeGameStates = [
  'waiting',
  'selection',
  'teleport-start',
  'ram-start',
  'cross-start',
  'color-start',
  'hammer-start',
];

export const boosterBGOpacity = 0.8;

export const BACKGROUND_SIZE = {
  width: 3390,
  height: 896,
  offsetX: 180,
};

const fieldSideLength = 270;

const BASE_SETTINGS = {
  applicationSettings: { transparent: true },
  width: fieldSideLength,
  height: fieldSideLength,
  bottomOffset: {
    desktop: fieldSideLength / 3,
    mobile: fieldSideLength / 15,
  },
  room: {
    portalOffset: -270,
    sideMobileOffset: 185,
  },
  fieldScale: {
    mobile: 1,
    desktop: 1,
  },
  resizeSize: {
    width: fieldSideLength,
    height: fieldSideLength,
  },
  mapOffset: {
    x: 0,
    y: 0,
  },
  minSize: 5,
  maxSize: 7,
  defaultSize: 5,

  field: {
    position: {
      x: 0,
      y: 335,
    },
    offset: {
      x: 0,
      y: 0,
    },
    item: {
      sizeRelativeToBlock: 0.9,
    },
    block: {
      baseScale: 0.13,
      width: 50,
      height: 50,
    },
  },
};

const bustersData = [
  {
    label: 'gameMatch3Settings.busters.ram.label',
    name: 'ram',
    count: 1,
  },
  {
    label: 'gameMatch3Settings.busters.cross.label',
    name: 'cross',
    count: 1,
  },
  {
    label: 'gameMatch3Settings.busters.color.label',
    name: 'color',
    count: 1,
  },
];

const BOOSTERS = {
  changeField: { isInstantly: false },
  color: { isInstantly: false },
  teleport: { isInstantly: false },
  hammer: { isInstantly: false },
  cross: { isInstantly: false },
  fireworks: { isInstantly: false },
  ram: { isInstantly: false },
  wand: { isInstantly: false },
  elixir: { isInstantly: true, attack: 2 },
  heal: { isInstantly: true, hp: 10 },
};

const particleAnimation = {
  delta: 40,
  duration: 0.9,
  deltaDuration: 0.5,
  endOffset: { x: 400, y: 350 },
};

export const teleportClip = 'teleportFront';

const interactiveBonuses = [
  'extraPeriod',
  'teleport',
  'extraPoints',
  'horizontal',
  'oneColor',
  'across',
  'timer',
  'color',
];

export { BASE_SETTINGS, interactiveBonuses, states, particleAnimation, BOOSTERS, bustersData };
